import {
  ADD_UPDATE_ORDER_ENTRY_CUSTOMER_FAILURE,
  ADD_UPDATE_ORDER_ENTRY_CUSTOMER_REQUEST,
  ADD_UPDATE_ORDER_ENTRY_CUSTOMER_SUCCESS,
  ADD_UPDATE_ORDER_ENTRY_VENDOR_REQUEST,
  ADD_UPDATE_ORDER_ENTRY_VENDOR_SUCCESS,
  ADD_UPDATE_ORDER_ENTRY_VENDOR_FAILURE,
  FETCH_ORDER_ENTRY_CUSTOMERS_FAILURE,
  FETCH_ORDER_ENTRY_CUSTOMERS_REQUEST,
  FETCH_ORDER_ENTRY_CUSTOMERS_SUCCESS,
  FETCH_ORDER_ENTRY_VENDORS_FAILURE,
  FETCH_ORDER_ENTRY_VENDORS_REQUEST,
  FETCH_ORDER_ENTRY_VENDORS_SUCCESS,
  FETCH_CUSTOMER_REFERENCES_REQUEST,
  FETCH_CUSTOMER_REFERENCES_SUCCESS,
  FETCH_CUSTOMER_REFERENCES_FAILURE,
  FETCH_LOZIER_DIMENSIONS_REQUEST,
  FETCH_LOZIER_DIMENSIONS_SUCCESS,
  FETCH_LOZIER_DIMENSIONS_FAILURE,
  FETCH_VENDORSERVICETYPES_REQUEST,
  FETCH_VENDORSERVICETYPES_SUCCESS,
  FETCH_VENDORSERVICETYPES_FAILURE,
  ADD_UPDATE_VENDORSERVICETYPES_REQUEST,
  ADD_UPDATE_VENDORSERVICETYPES_SUCCESS,
  ADD_UPDATE_VENDORSERVICETYPES_FAILURE,
} from "./actionTypes";

import {
  Customers,
  Vendors,
  CustomerReference,
  WeightDimensions,
  VendorServiceTypes,
} from "./types";

export const fetchCustomersRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
    isDropdown: boolean | null;
    goLiveDate: string | null;
  },
) => ({
  type: FETCH_ORDER_ENTRY_CUSTOMERS_REQUEST,
  url,
  payload,
});

export const fetchCustomersSuccess = (
  customers: Customers[],
  totalCount: number,
) => ({
  type: FETCH_ORDER_ENTRY_CUSTOMERS_SUCCESS,
  payload: { customers, totalCount },
});

export const fetchCustomersFailure = (error: string) => ({
  type: FETCH_ORDER_ENTRY_CUSTOMERS_FAILURE,
  payload: error,
});

export const addUpdateCustomerRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_ORDER_ENTRY_CUSTOMER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCustomerSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_ORDER_ENTRY_CUSTOMER_SUCCESS,
  payload: { successMessage },
});

export const addUpdateCustomerFailure = (error: string) => ({
  type: ADD_UPDATE_ORDER_ENTRY_CUSTOMER_FAILURE,
  payload: error,
});

export const fetchVendorsRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
    isDropdown: boolean | null;
    goLiveDate: string | null;
  },
) => ({
  type: FETCH_ORDER_ENTRY_VENDORS_REQUEST,
  url,
  payload,
});

export const fetchVendorsSuccess = (
  vendors: Vendors[],
  totalCount: number,
) => ({
  type: FETCH_ORDER_ENTRY_VENDORS_SUCCESS,
  payload: { vendors, totalCount },
});

export const fetchVendorsFailure = (error: string) => ({
  type: FETCH_ORDER_ENTRY_VENDORS_FAILURE,
  payload: error,
});

export const addUpdateVendorRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_ORDER_ENTRY_VENDOR_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateVendorSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_ORDER_ENTRY_VENDOR_SUCCESS,
  payload: { successMessage },
});

export const addUpdateVendorFailure = (error: string) => ({
  type: ADD_UPDATE_ORDER_ENTRY_VENDOR_FAILURE,
  payload: error,
});
export const fetchCustomerReferencesRequest = (
  url: string,
  customerId?: number,
) => ({
  type: FETCH_CUSTOMER_REFERENCES_REQUEST,
  url,
  payload: { customerId },
});
export const fetchCustomerReferencesSuccess = (
  customerReferences: CustomerReference[],
) => ({
  type: FETCH_CUSTOMER_REFERENCES_SUCCESS,
  payload: { customerReferences },
});

export const fetchCustomerReferencesFailure = (error: string) => ({
  type: FETCH_CUSTOMER_REFERENCES_FAILURE,
  payload: error,
});

export const fetchLozierDimensionsRequest = (url: string) => ({
  type: FETCH_LOZIER_DIMENSIONS_REQUEST,
  url,
  payload: {},
});
export const fetchLozierDimensionsSuccess = (
  weightDimensions: WeightDimensions[],
) => ({
  type: FETCH_LOZIER_DIMENSIONS_SUCCESS,
  payload: { weightDimensions },
});

export const fetchLozierDimensionsFailure = (error: string) => ({
  type: FETCH_LOZIER_DIMENSIONS_FAILURE,
  payload: error,
});

export const fetchVendorServiceTypesRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  },
) => ({
  type: FETCH_VENDORSERVICETYPES_REQUEST,
  url,
  payload,
});

export const fetchVendorServiceTypesSuccess = (
  vendorServiceTypes: VendorServiceTypes[],
  totalCount: number,
) => ({
  type: FETCH_VENDORSERVICETYPES_SUCCESS,
  payload: { vendorServiceTypes, totalCount },
});

export const fetchVendorServiceTypesFailure = (error: string) => ({
  type: FETCH_VENDORSERVICETYPES_FAILURE,
  payload: error,
});

export const addUpdateVendorServiceTypesRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_VENDORSERVICETYPES_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateVendorServiceTypesSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_VENDORSERVICETYPES_SUCCESS,
  payload: { successMessage },
});

export const addUpdateVendorServiceTypesFailure = (error: string) => ({
  type: ADD_UPDATE_VENDORSERVICETYPES_FAILURE,
  payload: error,
});
